import { Component, Element, h, Host, Prop } from '@stencil/core'

import Helpers from '../../utils/helpers'
import { CssClassMap } from '../../utils/interfaces'

/**
 * Para uma descrição detalhada, consulte a [documentação do GovBR-DS](https://www.gov.br/ds/components/table?tab=designer).
 *
 * @slot default - Descrição do slot
 */
@Component({
  tag: 'br-table',
  styleUrl: 'table.scss',
  shadow: true,
})
export class Table {
  /**
   * Referência ao elemento host do componente.
   * Utilize esta propriedade para acessar e manipular o elemento do DOM associado ao componente.
   */
  @Element() el: HTMLBrTableElement

  /**
   * Identificador único aplicado na tag raiz do shadowRoot.
   * Caso não seja fornecido, um ID gerado automaticamente será usado.
   */
  @Prop({ reflect: true }) readonly customId: string = Helpers.generateUniqueId()

  /**
   * Define um conjunto de classes CSS que serão aplicadas ao componente.
   * @returns Conjunto de classes CSS.
   */
  private getCssClassMap(): CssClassMap {
    return {
      'br-table': true,
    }
  }

  /**
   * Define o JSX do componente.
   * @return JSX do componente.
   */
  render() {
    return (
      <Host>
        <div id={this.customId} class={this.getCssClassMap()}>
          <slot name="tool-bar"></slot>
          <slot name="header"></slot>
          <slot name="row"></slot>
          <slot name="footer"></slot>
        </div>
      </Host>
    )
  }
}
